import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import ErrorIcon from "../../../assets/images/404-image.png";
import PropTypes from "prop-types";

const PageNotFound = (props) => {
  const {setData}  = props;
  useEffect(() => {
    document.body.classList.add("gray-background");
  }, []);
 

  return (
    <Container className="wentwrong">
      <Row>
        <Col lg={{ span: 8, offset: 2 }}>
          <div role="alert" aria-live="assertive" className="wentwrong__block">
            <img
              src={ErrorIcon}
              alt="Error Icon"
              aria-hidden="true"
              className="wentwrong__block-icon"
            />
            {setData && setData.map((language, index) => ( 
              <p className="wentwrong__block-desc" key={index}>
                {language.props ? 
                language.props.children:''}
            </p>   
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
};
PageNotFound.propTypes = {
    setData: PropTypes.array.isRequired,
  };
  PageNotFound.defaultProps = {
   
    setData: "",
    
  };
export default PageNotFound;